import React from "react";
import styles from "../styles";

const TermsAndCondition = () => {
  return (
    <React.Fragment>
      <span className="root">
        <span className="header">
          CONTRATO DE LICENÇA DE USUÁRIO FINAL DE SOFTWARE DA TREND AnyWARE®
        </span>

        <span className="lineBreak">
          AO CLICAR NO BOTÃO “ACEITAR”, ABAIXO, VOCÊ CONCORDA EM SER VINCULADO
          AOS TERMOS DESTE CONTRATO DE LICENÇA DE USUÁRIO FINAL (END USER
          LICENSE AGREEMENT, “EULA”)
        </span>

        <span className="lineBreak">
          Este Contrato de Licença de Usuário Final, conforme venha a ser
          alterado por nós de tempos em tempos, de acordo com a seção 12 (
          <b>“EULA”</b>), é um contrato legalmente vinculante entre você (pessoa
          física ou jurídica) e a TREND Networks Limited (<b>“TREND”</b>)
          referente ao seu acesso e uso do software TREND AnyWARE® que acompanha
          este EULA, podendo incluir mídia associada, materiais impressos,
          documentação on-line ou eletrônica, e serviços baseados na internet (
          <b>“Software”</b>). O Software permite que você acesse e interaja com
          dados de equipamentos, dispositivos e ferramentas de testes TREND
          compatíveis (<b>“Ferramentas”</b>). O Software pode ser acessado
          utilizando-se um navegador da Web em qualquer dispositivo ou baixado e
          instalado em um computador.
        </span>

        <span className="lineBreak">
          <b>IMPORTANTE – LEIA ATENTAMENTE OS TERMOS DESTE EULA.</b>
          ELE CONTÉM TERMOS IMPORTANTES QUE AFETAM VOCÊ E SEU USO DO SOFTWARE, E
          PRECISA SER AVALIADO POR VOCÊ COM RELAÇÃO À VERSÃO ATUAL DO EULA
          CONFORME E QUANDO FOR IMPLEMENTADO. AO CRIAR UMA CONTA, INSTALAR OU DE
          OUTRA FORMA ACESSAR OU USAR O SOFTWARE OU QUALQUER PARTE DELES, VOCÊ
          CONCORDA QUE LEU, ENTENDEU E CONCORDA EM ESTAR VINCULADO AOS TERMOS
          DESTE EULA EM SEU PRÓPRIO NOME E, CONFORME APLICÁVEL, EM NOME DA
          EMPRESA OU ENTIDADE QUE EMPREGA VOCÊ OU QUE VOCÊ REPRESENTA. SE VOCÊ
          NÃO CONCORDAR, NÃO ACESSE, INSTALE, COPIE OU USE O SOFTWARE, E SE VOCÊ
          NÃO CONCORDAR COM QUALQUER ALTERAÇÃO DESTE CONTRATO, VOCÊ NÃO TERÁ
          MAIS DIREITO OU LICENÇA PARA ACESSAR OU USAR O SOFTWARE E DEVERÁ
          DESINSTALAR E/OU INTERROMPER IMEDIATAMENTE O ACESSO OU USO DO
          SOFTWARE.
        </span>

        <span className="lineBreak">
          VOCÊ DECLARA E GARANTE QUE ESTÁ CELEBRANDO ESTE EULA PARA A SUA
          ATIVIDADE COMERCIAL OU PARA FINS COMERCIAIS (E NÃO COMO CONSUMIDOR).
          NO ENTANTO, EM CASO DE APLICAÇÃO DE ALGUMA LEI DE PROTEÇÃO AO
          CONSUMIDOR SEGUNDO A LEGISLAÇÃO APLICÁVEL, ESTE EULA NÃO AFETARÁ NEM
          PREJUDICARÁ OS DIREITOS DE CONSUMIDOR PREVISTOS POR LEI QUE VOCÊ POSSA
          TER NOS TERMOS DA LEI APLICÁVEL. SE VOCÊ ESTIVER CELEBRANDO ESTE EULA
          EM NOME DE UMA EMPRESA OU OUTRA PESSOA JURÍDICA, VOCÊ DECLARA E
          GARANTE QUE TEM AUTORIDADE PARA VINCULAR TAL EMPRESA OU ENTIDADE AOS
          TERMOS DESTE EULA, E, NESSE CASO, OS TERMOS “VOCÊ” OU “SEU(S)/SUA(S)”
          TAMBÉM SE REFERIRÃO À EMPRESA OU ENTIDADE QUE VOCÊ REPRESENTE OU QUE
          LHE EMPREGUE E SUAS RESPECTIVAS AFILIADAS E CADA UM DE SEUS
          CONSELHEIROS, DIRETORES, FUNCIONÁRIOS, AGENTES E REPRESENTANTES.
        </span>

        <ol>
          <li>
            <b> USO DO SOFTWARE</b>
            <ol>
              <li>
                Sujeito à sua conformidade com os termos deste EULA, a TREND
                concede a você um direito e licença intransferíveis, não
                sublicenciáveis, revogáveis e limitados para baixar, instalar,
                ativar, acessar ou de outra forma usar versões de código-objeto
                do Software em um dispositivo de sua propriedade ou controle,
                única e exclusivamente para suas operações internas, conforme
                permitido por este EULA.
              </li>
              <li>
                Você poderá conceder a terceiros e/ou usuários dentro de sua
                empresa ou organização (<b>“Usuários Autorizados”</b>) o direito
                de acessar e usar o Software no curso regular de seu trabalho se
                tal uso for apenas: (i) em seu nome; (ii) para suas operações
                internas; e (iii) em conformidade com este EULA. Você garantirá
                que todos os seus Usuários Autorizados concordem em cumprir os
                termos deste EULA e tenham autorizado e sido notificados sobre a
                coleta, o uso e o compartilhamento de suas informações pessoais
                pela TREND de acordo com os termos da Política de Privacidade da
                TREND antes de fornecer aos seus Usuários Autorizados acesso ao
                Software. Todas as referências a “você” ou “seu(s)/sua(s)” neste
                EULA também serão interpretadas como referência aos seus
                Usuários Autorizados. Você é responsável por: (a) identificar e
                autenticar todos os Usuários Autorizados; (b) aprovar o acesso
                por tais Usuários Autorizados ao Software; (c) garantir a
                conformidade dos Usuários Autorizados com este EULA; (d)
                controlar o acesso não autorizado ou o uso por Usuários
                Autorizados; (e) manter a confidencialidade dos nomes de
                usuários, senhas e informações da conta; e (f) fornecer ou obter
                quaisquer notificações ou consentimentos necessários dos
                Usuários Autorizados conforme exigido pela lei aplicável,
                incluindo, sem limitação, antes de ativar o recurso de
                rastreamento de localização nas Ferramentas. A TREND não é
                responsável por qualquer dano causado por seus Usuários
                Autorizados, inclusive indivíduos que não estavam autorizados a
                ter acesso ao Software, mas que puderam obter acesso porque
                nomes de usuários, senhas ou contas não foram encerrados em
                tempo hábil em sua infraestrutura de gerenciamento de identidade
                local, seus dispositivos locais, ou de outra forma por você ou
                em seu nome. Você é responsável por todas as atividades que
                ocorram em senhas, contas ou nomes seus ou dos seus Usuários
                Autorizados ou a eles relacionados, ou resultantes do seu acesso
                ou do acesso dos seus Usuários Autorizados ao Software, e você
                concorda em notificar a TREND imediatamente por escrito sobre
                qualquer uso não autorizado. Você concorda em empreender todos
                os esforços possíveis para impedir que terceiros não autorizados
                acessem o Software. Você será responsável por todos os atos e
                omissões de qualquer Usuário Autorizado e indenizará a TREND por
                todos os custos, despesas, reivindicações, perdas ou danos
                incorridos ou sofridos pela TREND, ou pelos quais a TREND venha
                a ser responsabilizada (sejam diretos, indiretos ou
                consequentes, inclusive por prejuízos econômicos ou outros
                lucros cessantes ou perdas de negócios ou de fundo de comércio)
                decorrentes de ato ou omissão de Usuário Autorizado.
              </li>
              <li>
                Você deve designar um ou mais Usuários Autorizados como
                administrador (<b>“Administrador”</b>) da sua conta. Você
                concorda que o Administrador poderá, em seu nome, conceder e
                revogar o acesso e os direitos de uso de outros Usuários
                Autorizados, a qualquer momento e por qualquer motivo. Você
                poderá alterar seu(s) administrador(es) a qualquer momento e por
                qualquer motivo atualizando sua designação.
              </li>
              <li>
                Você concorda que é o único responsável (e que a TREND não tem
                nenhuma responsabilidade perante você ou terceiros) pelo seu uso
                do Software, pela violação de suas obrigações previstas neste
                EULA, e pelas consequências (inclusive perdas ou danos que a
                TREND venha a sofrer) de qualquer violação.
              </li>
              <li>
                Você poderá acessar o Software em seus dispositivos usando um
                navegador da Web. Uma versão independente poderá ser baixada e
                instalada em um PC executando o Microsoft Windows. A versão
                independente permite a comunicação com as ferramentas via
                conexão direta, não pela internet.
              </li>
              <li>
                Para baixar, instalar, ativar, acessar ou usar o software, será
                solicitado que você registre uma conta. A TREND reserva-se o
                direito, a seu exclusivo e absoluto critério, de recusar
                qualquer registro. Em troca do seu uso do software, você
                concorda em: (i) fornecer informações de conta precisas, atuais
                e completas; (ii) manter e atualizar imediatamente as
                informações da sua conta; (iii) manter a segurança da(s) sua(s)
                senha(s) e aceitar todos os riscos de acesso não autorizado à
                sua conta e às informações que você fornecer à TREND; e (iv) nos
                notificar imediatamente se você descobrir ou suspeitar de
                violação de segurança relacionada ao Software ou ao seu uso
                dele.
              </li>
              <li>
                Para permitir que a TREND realize o serviço, a manutenção e o
                suporte do software, você concederá à TREND o acesso que a TREND
                solicitar para que a TREND possa acessar e operar a sua conta
                como se ela estivesse sendo operada por você. Esse acesso
                autorizado inclui o direito de a TREND visualizar, modificar e
                excluir seus dados.
              </li>
              <li>
                Na medida permitida por lei, a TREND poderá excluir qualquer um
                dos seus dados no caso de ato ou omissão de sua parte que não
                esteja em conformidade com este EULA. A TREND tentará notificar
                você antes da exclusão dos seus dados, mas não terá violado este
                EULA se não o fizer. Se você baixar seus dados e excluí-los dos
                nossos servidores ou dos servidores dos nossos terceiros, os
                dados baixados e excluídos não estarão mais acessíveis através
                do Software ou dos nossos servidores ou dos servidores dos
                nossos terceiros.
              </li>
              <li>
                Você é o único responsável por fornecer e manter, às suas
                próprias expensas, todos os equipamentos, as ferramentas, o
                software, os serviços, e outros itens necessários para usar o
                Software e as Ferramentas (inclusive, sem limitação, hardware ou
                software de computador ou dispositivo, modems, serviço
                telefônico e acesso à internet).
              </li>
              <li>
                Você reconhece que seu uso do Software poderá exigir conexão com
                a Internet e que isso poderá incorrer-lhe cobranças de dados
                relacionadas às informações transmitidas (sejam enviadas ou
                recebidas) pelo seu dispositivo enquanto estiver usando o
                Software. Você é o único responsável por tais cobranças de
                dados.
              </li>
            </ol>
          </li>

          <li>
            <b>2. RESERVA DE DIREITOS E PROPRIEDADE</b>
            <ol>
              <li>
                O Software é licenciado, não vendido, para você para uso apenas
                de acordo com os termos deste EULA. Título, propriedade e todos
                os direitos de e para: (i) o Software (inclusive, sem limitação,
                todos os direitos de propriedade intelectual); e (ii) todo o
                conteúdo e outros materiais fornecidos pela TREND ou pelos
                nossos licenciadores terceirizados, inclusive, sem limitação, os
                logotipos TREND e TREND AnyWARE® e todos os designs, textos,
                gráficos, fotos, informações, dados, software, arquivos de som,
                outros arquivos e sua seleção e organização (em conjunto,
                “Conteúdo”), são propriedade exclusiva da TREND ou de nossos
                licenciadores, conforme aplicável, e estão protegidos por
                direitos autorais e outros direitos de propriedade intelectual e
                leis aplicáveis e permanecerão com a TREND. A TREND reserva-se
                todos os direitos não expressamente concedidos a você neste
                EULA, e nenhum outro direito é concedido, seja expresso ou
                implícito.
              </li>
              <li>
                “TREND”, “TREND Networks”, “TREND AnyWARE”, “LanTEK”, “TREND
                Networks”, “FiberTEK”, “SignalTEK”, “NaviTEK”, “SecuriTEST”,
                “LanXPLORER”, “UniPRO MGig1”, os logotipos TREND Networks e
                TREND AnyWARE® e quaisquer outros nomes, logotipos ou slogans de
                produtos ou serviços TREND que venham a aparecer no Software ou
                no Conteúdo são marcas comerciais da TREND, e nem eles, nem
                quaisquer nomes de logotipos ou slogans semelhantes passíveis de
                causar confusão poderão ser copiados, imitados ou usados, no
                todo ou em parte, sem a prévia permissão por escrito da TREND.
                As marcas de terceiros que apareçam no Software ou no Conteúdo
                são de propriedade de terceiros e não poderão ser usadas sem a
                permissão do titular da respectiva marca comercial. Você não
                poderá usar metatags ou outro “texto oculto” utilizando “TREND”
                ou qualquer outro nome, marca comercial ou nome do produto ou
                serviço da TREND sem nossa permissão prévia por escrito. Além
                disso, a aparência do software, inclusive todos os cabeçalhos de
                página, gráficos personalizados, ícones de botões e scripts, são
                a marca de serviço, marca comercial e/ou traje comercial da
                TREND e não podem ser copiados, imitados ou usados, no todo ou
                em parte, sem nossa permissão prévia por escrito. As referências
                a produtos, serviços, processos ou outras informações, pelo
                nome, marca comercial, fabricante, fornecedor ou de outra forma
                não constituem ou implicam endosso, patrocínio ou recomendação
                deles pela TREND.
              </li>
            </ol>
          </li>

          <li>
            <b> RESTRIÇÕES E LIMITAÇÕES </b>
            <ol>
              <li>
                Você compreende e concorda que só usará o Software em
                conformidade com todas as leis aplicáveis na jurisdição onde
                você usar o Software. Se você violar este EULA, você poderá ser
                processado e ser obrigado compensar prejuízos.
              </li>
              <li>
                Você não praticará os seguintes atos nem permitirá a terceiros:
                <ol>
                  <li>
                    baixar, instalar, ativar, acessar ou de outra forma usar o
                    Software ou o Conteúdo em qualquer dispositivo que não seja
                    de sua propriedade ou que não esteja sob o seu controle
                    legal;
                  </li>
                  <li>
                    publicar, discutir, liberar, transmitir ou de outra forma
                    disseminar a terceiros os resultados de testes obtidos a
                    partir do uso das Ferramentas;
                  </li>
                  <li>
                    traduzir, mesclar, adaptar, variar, alterar ou modificar o
                    Software, no todo ou em parte, nem permitir que nenhuma
                    parte dele seja incorporada a ou combinada com outros
                    programas;
                  </li>
                  <li>
                    fazer engenharia reversa, descompilar, tentar derivar o
                    código-fonte de, modificar ou desmontar, no todo ou em
                    parte, o software, exceto e apenas na medida em que tal
                    atividade seja expressamente permitida pela lei aplicável;
                  </li>
                  <li>
                    remover ou alterar quaisquer avisos ou marcas de propriedade
                    no Software;
                  </li>
                  <li>
                    criar trabalhos derivados com base em todo ou parte do
                    Software;
                  </li>
                  <li>
                    copiar ou reproduzir o Software fora da sua organização;
                  </li>
                  <li>
                    vender, ceder, licenciar, distribuir, alugar, arrendar,
                    sublicenciar, emprestar ou fornecer ou disponibilizar o
                    software, de qualquer forma, no todo ou em parte a qualquer
                    pessoa sem o prévio consentimento por escrito da TREND;
                  </li>
                  <li>
                    usar o Software de maneira ilegal, para qualquer finalidade
                    ilegal, ou de maneira inconsistente com estes termos, ou
                    agir de forma fraudulenta ou maliciosa, por exemplo,
                    hackeando ou inserindo código malicioso, como vírus, ou
                    dados prejudiciais, no Software ou em qualquer sistema
                    operacional;
                  </li>
                  <li>
                    infringir nossos direitos de propriedade intelectual ou de
                    terceiros em relação ao seu uso do Software, inclusive pelo
                    envio de qualquer material (na medida em que tal uso não
                    seja licenciado por estes termos);
                  </li>
                  <li>
                    transmitir qualquer material que seja difamatório, ofensivo
                    ou de outra forma censurável em relação ao seu uso do
                    Software;
                  </li>
                  <li>
                    usar o Software de qualquer forma que possa danificar,
                    desativar, sobrecarregar ou prejudicar o Software (ou
                    servidores ou redes conectadas ao Software);
                  </li>
                  <li>
                    usar o Software de forma que possa interferir no uso e na
                    satisfação de outra pessoa do Software (ou de servidores ou
                    redes conectadas ao Software);
                  </li>
                  <li>
                    desenvolver aplicativos de terceiros que interajam com o
                    Software sem o prévio consentimento por escrito da TREND;
                  </li>
                  <li>
                    coletar ou recolher informações ou dados através do uso do
                    Software ou dos sistemas da TREND ou tentar decifrar
                    transmissões para ou dos servidores que executam o Software;
                    ou
                  </li>
                  <li>
                    coletar ou recolher informações ou dados através do uso do
                    Software ou dos sistemas da TREND ou tentar decifrar
                    transmissões para ou dos servidores que executam o Software;
                    ou
                  </li>
                </ol>
              </li>
            </ol>
          </li>

          <li>
            <b> COLETA E USO DE DADOS</b>
            <ol>
              <li>
                Você concorda que a TREND e suas afiliadas poderão coletar e
                usar informações técnicas coletadas como parte dos serviços de
                suporte do produto fornecidos a você, se houver, relacionadas ao
                Software. A TREND poderá usar essas informações exclusivamente
                para melhorar nossos produtos ou fornecer serviços ou
                tecnologias customizados para você e não divulgará essas
                informações em um formulário que identifique você pessoalmente.
              </li>
              <b class="subHeading">Dados Pessoais</b>
              <li>
                Você está ciente que quando você baixar, instalar, ativar,
                acessar ou de outra forma usar o software, a TREND poderá usar
                meios automáticos (inclusive, por exemplo, cookies e web
                beacons) para coletar informações sobre seu dispositivo e sobre
                seu uso do Software. Você e seus Usuários Autorizados também
                poderão ser obrigados a fornecer certas informações pessoais
                como condição para baixar, instalar, ativar, acessar ou usar o
                Software ou determinados recursos ou funcionalidades do
                Software. Segundo a legislação de proteção de dados, somos
                obrigados a fornecer certas informações sobre quem somos, como e
                para que processamos seus dados pessoais, seus direitos em
                relação aos seus dados pessoais e como exercê-los. Essas
                informações são fornecidas na política de privacidade da TREND,
                disponível em
                <a
                  href="https://www.trend-networks.com/UK/EN/Privacy-Policy.aspx"
                  target="_blank"
                >
                  <b>
                    https://www.trend-networks.com/UK/EN/Privacy-Policy.aspx
                  </b>
                </a>
                , que poderá ser atualizada de tempos em tempos sem aviso prévio
                (<b>“Política de Privacidade”</b>) e é importante que você leia
                a Política de Privacidade. Ao baixar, instalar, ativar, acessar
                ou usar o Software e fornecer informações para ou através do
                Software, você autoriza todos os usos e ações realizados pela
                TREND com relação às suas informações de acordo com a Política
                de Privacidade.
              </li>
              <li>
                Esteja ciente de que transmissões da internet nunca são
                completamente privadas ou seguras e que qualquer mensagem ou
                informação que você enviar usando o Software poderá ser lida ou
                interceptada por terceiros, mesmo se houver um aviso especial
                informando que a transmissão específica é criptografada.
              </li>
              <b class="subHeading">Dados do Usuário Final</b>
              <li>
                Com relação ao software, a TREND poderá coletar e manter dados
                inseridos ou carregados por você ou em seu nome através do
                Software, inclusive, entre outros, informações relacionadas ao
                seu uso das Ferramentas e aos Usuários Autorizados (
                <b>“Dados do Usuário Final”</b>). Você será o proprietário de
                todos os Dados do Usuário Final e, pelo presente, concorda que
                você é o único responsável pelos Dados do Usuário Final. A TREND
                manterá o sigilo de todos os aspectos pessoais identificáveis de
                todos os Dados do Usuário Final de acordo com a Política de
                Privacidade. Todos os terceiros autorizados pela TREND que
                venham a ter acesso aos Dados do Usuário Final terão obrigações
                de confidencialidade e estarão obrigados a cumprir todas as leis
                de proteção de dados pertinentes. Pelo presente, você concorda e
                concede à TREND o direito e a licença irrevogáveis, perpétuos,
                livres de royalties, transferíveis e sublicenciáveis para usar,
                reproduzir, modificar, adaptar, traduzir, divulgar,
                comercializar, ceder, transmitir, vender, arrendar, licenciar ou
                transferir Dados de Usuário Final, no todo ou em parte, na
                medida em que não contenham dados pessoais. Ao carregar ou
                transmitir Dados de Usuário Final usando o software, você
                declara e garante que: (i) os Dados de Usuário Final não estão
                sujeitos a obrigações de confidencialidade de terceiros que
                seriam violadas pelo uso dos Dados de Usuário Final nos termos
                deste EULA; (ii) você possui e controla todos os direitos dos
                Dados de Usuário Final que você criar, carregar ou transmitir,
                ou que você tem todos os direitos necessários para criar,
                carregar ou transmitir os Dados de Usuário Final usando o
                software; (iii) os Dados de Usuário Final são precisos e não são
                enganosos nem prejudiciais de forma alguma; e (iv) os Dados de
                Usuário Final e seu uso e carregamento, e sua transmissão não
                violam e não violarão os termos deste EULA nem de qualquer lei,
                regra ou regulamento aplicável. Não obstante outros termos deste
                EULA, a TREND, a qualquer momento, poderá: (a) excluir quaisquer
                Dados de Usuário Final e/ou (b) suspender sua conta e acessar o
                Software. Você garantirá que reterá cópias de todos os Dados de
                Usuário Final carregados, transmitidos ou enviados para a TREND
                através do Software, e a TREND não terá nenhuma responsabilidade
                para com você por qualquer perda de Dados de Usuário Final, nem
                por qualquer perda de uso do Software.
              </li>
              <b class="subHeading">Dados da TREND</b>
              <li>
                Todas as informações, inclusive, sem limitação, dados, análises,
                medições, relatórios, tendências e métricas, geradas ou
                derivadas dos Dados do Usuário Final (<b>“Dados da TREND”</b>),
                ou neles baseadas ou a eles relacionadas são propriedade
                exclusiva da TREND. A TREND tem o direito de usar, coletar,
                armazenar, criar, agregar, prospectar, analisar, modificar,
                comercializar, ceder, transmitir, vender, arrendar, licenciar ou
                transferir Dados da TREND em qualquer formato, para qualquer
                finalidade e de qualquer maneira.
              </li>
            </ol>
          </li>

          <li>
            <b> ATUALIZAÇÕES</b>
            <ol>
              <li>
                A TREND poderá modificar o software sem aviso prévio, inclusive,
                sem limitação, alterar a funcionalidade ou a aparência do
                Software.
              </li>
              <li>
                A TREND poderá, de tempos em tempos, a seu exclusivo critério,
                desenvolver e fornecer atualizações de software, como upgrades,
                correções de bug, patches e outras correções de erros e/ou novos
                recursos (em conjunto, inclusive documentação relacionada,
                “Atualizações”). As atualizações também poderão modificar ou
                excluir em sua totalidade determinados recursos e
                funcionalidades. Você concorda que a TREND não tem nenhuma
                obrigação de fornecer atualizações nem de continuar a fornecer
                ou habilitar quaisquer recursos ou funcionalidades específicos.
                Com base nas configurações do seu dispositivo, quando seu
                dispositivo estiver conectado à Internet: (i) o Software baixará
                e instalará automaticamente todas as Atualizações disponíveis;
                ou (ii) você poderá receber notificação ou receber solicitação
                para baixar e instalar Atualizações disponíveis. Para poder
                utilizar totalmente o software, você deve fazer o download e
                instalar todas as atualizações imediatamente. Você reconhece que
                o Software ou suas partes poderão não funcionar adequadamente
                caso você não consiga fazer a atualização. Você concorda ainda
                que todas as Atualizações serão consideradas parte do Software e
                estarão sujeitas a todos os termos e condições deste EULA.
              </li>
            </ol>
          </li>

          <li>
            <b> LINKS PARA SITES DE TERCEIROS E SUPORTE </b>
            <ol>
              <li>
                Você poderá acessar links para sites de terceiros através do uso
                do Software (por exemplo, para o TeamViewer, uma plataforma de
                suporte de desktop remoto e impressora de etiquetas externa). Os
                sites de terceiros não estão sob o controle da TREND, e a TREND
                não é responsável pelo conteúdo de sites de terceiros, por links
                contidos em sites de terceiros, ou por alterações ou
                atualizações em sites de terceiros. A TREND não é responsável
                pela webcasting ou por qualquer outra forma de transmissão
                recebida de sites de terceiros. A TREND está fornecendo esses
                links para sites de terceiros para você apenas como
                conveniência, e a inclusão de algum link não implica um endosso
                pela TREND do site de terceiros.
              </li>
              <li>
                Se você desejar saber mais sobre o Software ou tiver problemas
                para usá-lo, acesse{" "}
                <a
                  href="https://www.trend-networks.com/in/en/index.aspx"
                  target="_blank"
                >
                  <b>www.trend-networks.com</b>
                </a>{" "}
                para obter dados de contato de e-mail e telefone regional. A
                TREND não será obrigada a fornecer nenhum serviço de suporte nos
                termos deste EULA. Se algum suporte for exigido por você, isso
                poderá ser fornecido mediante solicitação com base no tempo e no
                custo. Este EULA não oferece a você nenhum direito a nenhuma
                atualização ou melhoria do Software ou a quaisquer extensões ou
                aprimoramentos do Software desenvolvidos pela TREND ou em nome
                dela a qualquer momento no futuro. A TREND poderá oferecer
                serviços de suporte separadamente. Qualquer código complementar
                de software ou materiais relacionados que a TREND fornecer para
                você como parte de serviços de suporte serão considerados parte
                do Software e estão sujeitos aos termos e condições deste EULA.
              </li>
            </ol>
          </li>

          <li>
            <b> INFORMAÇÕES CONFIDENCIAIS </b> <br />
            Você reconhece e concorda que o Software (excluindo qualquer
            Software de Código Aberto) e todas as informações que emanam do
            Software e dos negócios da TREND de qualquer forma são propriedade
            intelectual valiosa da TREND e são consideradas informações
            confidenciais da TREND (<b>“Informações Confidenciais”</b>). Você se
            compromete, durante ou após o término da vigência deste EULA, a não
            permitir a duplicação, o uso, ou a divulgação de Informações
            Confidenciais para ninguém, a menos que a duplicação, o uso ou a
            divulgação sejam especificamente autorizados por escrito pela TREND
            antes da divulgação. Você usará a diligência necessária, e, em
            hipótese alguma, menos do que o grau de cuidado que você emprega às
            suas próprias informações confidenciais de natureza semelhante, para
            evitar a divulgação ou a reprodução não autorizada das Informações
            Confidenciais. Sem limitar a generalidade do exposto acima, na
            medida em que este EULA permitir a realização de cópia de
            Informações Confidenciais, todas as cópias conterão os mesmos avisos
            de confidencialidade, legendas e designações de direitos de
            propriedade intelectual que aparecem nas versões originais, e a
            parte manterá registros detalhados do local de todas as Informações
            Confidenciais.
          </li>

          <li>
            <b> DIREITO DE RESCINDIR O EULA</b>
            <ol>
              <li>
                Este EULA continuará a ser aplicado até ser rescindido por você
                ou pela TREND, conforme declarado neste documento.
              </li>
              <li>
                Você poderá rescindir este EULA a qualquer momento, parando de
                acessar o Software e/ou desinstalando permanentemente o Software
                por completo do seu computador.
              </li>
              <li>
                Seus direitos serão automática e imediatamente rescindidos sem
                aviso da TREND se você não cumprir qualquer disposição deste
                EULA. Em tal evento, você deve parar imediatamente de acessar o
                Software e/ou desinstalar o Software.
              </li>
              <li>
                A TREND poderá rescindir o seu direito de usar o Software a
                qualquer momento, com ou sem aviso prévio. Os termos deste EULA
                relacionados ao uso de dados, à indenização, limitação de
                responsabilidade, confidencialidade, resolução de disputas e
                interpretação e formação de acordo sobreviverão à rescisão ou
                expiração deste EULA.
              </li>
            </ol>
          </li>

          <li>
            <b> INDENIZAÇÃO </b>
            <br />
            Até o limite máximo permitido por lei, você concorda em defender,
            indenizar e manter indene a TREND, suas subsidiárias e afiliadas, e
            seus respectivos conselheiros, diretores, funcionários e agentes de
            e contra todas e quaisquer reivindicações, ações, demandas ou
            controvérsias, bem como todas e quaisquer perdas, responsabilidades,
            indenizações, despesas e custas (inclusive honorários advocatícios
            razoáveis) decorrentes do seu uso (ou do uso de qualquer pessoa que
            esteja agindo com a sua conta ou senha) do Software, inclusive seu
            acesso e/ou instalação ou uso do Software, ou sua violação deste
            EULA.
          </li>

          <li>
            <b> LIMITAÇÃO DE RESPONSABILIDADE</b>
            <ol>
              <li>
                A TREND NÃO EXCLUI NEM LIMITA DE FORMA ALGUMA SUA PRÓPRIA
                RESPONSABILIDADE PARA COM VOCÊ NOS CASOS EM QUE FAZÊ-LO SERIA
                ILEGAL. ISSO INCLUI RESPONSABILIDADE POR MORTE OU LESÃO PESSOAL
                CAUSADA POR NEGLIGÊNCIA DA TREND OU DE SEUS FUNCIONÁRIOS,
                AGENTES OU SUBCONTRATADOS, OU POR FRAUDE OU FALSIDADE
                IDEOLÓGICA.
              </li>
              <li>
                VOCÊ ENTENDE E CONCORDA EXPRESSAMENTE QUE SEU USO DO SOFTWARE
                FICA A SEU EXCLUSIVO CRITÉRIO E RISCO, E QUE O SOFTWARE É
                FORNECIDO “NO ESTADO EM QUE SE ENCONTRA” E “CONFORME DISPONÍVEL”
                SEM GARANTIA DE QUALQUER TIPO, EXPRESSA OU IMPLÍCITA. VOCÊ É O
                ÚNICO RESPONSÁVEL POR QUALQUER DANO AO SEU COMPUTADOR, OU OUTRO
                DISPOSITIVO, OU PERDA DE DADOS QUE RESULTEM DE TAL USO. A TREND
                SE ISENTA EXPRESSAMENTE DE TODAS AS OUTRAS GARANTIAS E CONDIÇÕES
                DE QUALQUER TIPO, SEJAM EXPRESSAS OU IMPLÍCITAS, INCLUSIVE, SEM
                LIMITAÇÃO, GARANTIAS E CONDIÇÕES IMPLÍCITAS DE COMERCIALIZAÇÃO,
                ADEQUAÇÃO A UM PROPÓSITO ESPECÍFICO E NÃO VIOLAÇÃO, COM RELAÇÃO
                AO SOFTWARE. ALGUMAS JURISDIÇÕES NÃO PERMITEM RENÚNCIA OU
                EXCLUSÃO DE GARANTIAS IMPLÍCITAS, PORTANTO, ELAS PODERÃO NÃO SE
                APLICAR A VOCÊ. A TREND NÃO DÁ NENHUMA GARANTIA CONTRA
                INTERFERÊNCIAS NO SEU USO DO SOFTWARE, DE QUE AS FUNÇÕES
                CONTIDAS NO SOFTWARE OU OS SERVIÇOS REALIZADOS OU FORNECIDOS POR
                ELE ATENDERÃO AOS SEUS REQUISITOS, DE QUE A OPERAÇÃO DO SOFTWARE
                OU DOS SERVIÇOS SERÁ ININTERRUPTA OU ISENTA DE ERROS, OU DE QUE
                DEFEITOS NO SOFTWARE OU NOS SERVIÇOS SERÃO CORRIGIDOS. NENHUMA
                INFORMAÇÃO ORAL OU ESCRITA OU ORIENTAÇÃO DADA PELA TREND OU POR
                SEUS REPRESENTANTES AUTORIZADOS CRIARÁ UMA GARANTIA. TREND OR
                ITS AUTHORISED REPRESENTATIVES SHALL CREATE A WARRANTY.
              </li>
              <li>
                VOCÊ ESTÁ CIENTE E CONCORDA EXPRESSAMENTE QUE, EXCETO COM
                RELAÇÃO À SEÇÃO 10.1, A TREND, SUAS SUBSIDIÁRIAS E AFILIADAS, E
                SEUS LICENCIADORES NÃO TERÃO NENHUMA RESPONSABILIDADE PERANTE
                VOCÊ POR PERDAS OU DANOS DE QUALQUER NATUREZA OU VALOR, SEGUNDO
                QUALQUER TEORIA DE RESPONSABILIDADE, SEJAM OU NÃO AS PERDAS OU
                OS DANOS DIRETOS, INDIRETOS, INCIDENTAIS, ESPECIAIS,
                CONSEQUENCIAIS OU EXEMPLARES, E TENHAM OU NÃO AS PERDAS OU OS
                DANOS SIDO SOFRIDOS OU INCORRIDOS POR VOCÊ EM VIRTUDE DO SEU USO
                DO SOFTWARE, INCLUSIVE PERDAS DE DADOS OU DANOS AOS SEUS
                DISPOSITIVOS, E INDEPENDENTEMENTE DE VOCÊ OU SEUS REPRESENTANTES
                TEREM OU NÃO SIDO INFORMADOS OU SE DEVERIAM TER ESTADO CIENTES
                DA POSSIBILIDADE DE OCORRÊNCIA DESSAS PERDAS.
              </li>
              <li>
                FAÇA O BACKUP DO CONTEÚDO E DOS DADOS USADOS COM O SOFTWARE. A
                TREND RECOMENDA QUE VOCÊ FAÇA BACKUP DO CONTEÚDO E DOS DADOS
                USADOS RELATIVOS AO SOFTWARE PARA SE PROTEGER EM CASO DE
                PROBLEMAS COM O SOFTWARE.
              </li>
            </ol>
          </li>

          <li>
            <b> ALTERAÇÕES AO EULA </b>
            <br />A qualquer momento, por meio de aviso a você (seja por e-mail,
            on-line, através do Software ou de outra forma) especificando a
            alteração, a TREND poderá alterar o EULA (inclusive alterar as taxas
            devidas por você para uso do Software), sendo que a alteração será
            considerada efetiva no prazo de 30 (trinta) dias a contar da data da
            notificação. Você declarará estar ciente das alterações e concordará
            com elas, conforme especificado no aviso. A não declaração de
            ciência das alterações e a não concordância com elas darão direito à
            TREND de rescindir este EULA mediante aviso a você com 1 (um) mês de
            antecedência.
          </li>

          <li>
            <b> AVISOS </b>
            <ol>
              <li>
                Qualquer notificação ou outra comunicação dada a uma parte nos
                termos deste EULA ou a ele relacionada será feita por escrito e
                entregue em mãos ou por correio expresso pré-pago ou outro
                serviço de entrega expresso com prazo de um dia útil em seu
                escritório registrado (no caso de empresa) ou no seu local de
                negócios principal (em qualquer outro caso).
              </li>
              <li>
                Qualquer notificação ou comunicação será considerada recebida:
                (i) se entregue em mãos, mediante a assinatura de um recibo de
                entrega ou no momento em que a notificação for deixada no
                endereço correto; (ii) se enviada por correio pré-pago expresso
                ou por outro serviço de entrega expresso com prazo de um dia
                útil, às 9h no segundo dia útil após ser remetida ou no momento
                registrado pelo serviço de entrega; e (iii) se enviada por
                e-mail, no momento da transmissão, ou, se esse horário fora do
                horário comercial, no local de recebimento, quando o horário
                comercial for retomado (das 9h às 17h de segunda a sexta-feira,
                em um dia que não seja um feriado público no local de
                recebimento).
              </li>
            </ol>
          </li>

          <li>
            <b> LEI APLICÁVEL E FORO </b>
            Este EULA e qualquer disputa ou reivindicação (inclusive litígios ou
            reivindicações não contratuais) decorrentes dele ou de seu objeto ou
            de sua formação, ou a eles relacionados serão regidos e
            interpretados de acordo com a lei da Inglaterra e do País de Gales,
            e cada parte concorda irrevogavelmente que os tribunais da
            Inglaterra e do País de Gales terão competência exclusiva para
            resolver qualquer litígio ou reivindicação (inclusive litígios ou
            reivindicações não contratuais) decorrentes deste EULA ou de seu
            objeto ou de sua formação, ou a eles relacionados.
          </li>

          <li>
            <b>DIVERSOS</b>
            <br />
            Este EULA (inclusive qualquer adendo ou aditivo a este EULA)
            constitui o acordo integral entre você e a TREND referente ao
            Software e aos serviços de suporte (se houver) e substitui todas as
            comunicações orais ou escritas anteriores ou contemporâneas,
            propostas e declarações relativas ao Software ou a qualquer outro
            assunto abrangido por este EULA. Em caso de conflito entre os termos
            de políticas ou termos de serviços de suporte da TREND e os termos
            deste EULA, os termos deste EULA prevalecerão. Se alguma disposição
            deste EULA for considerada nula, inválida, inaplicável ou ilegal, a
            disposição será considerada reafirmada para refletir a vontade
            primeira das partes na medida máxima possível e de acordo com a lei
            aplicável, e as outras disposições continuarão em pleno vigor e
            efeito. O não exercício ou a não aplicação por parte da TREND de
            algum direito ou alguma disposição deste EULA não constituirá
            renúncia ao direito ou à disposição, a menos que isso seja declarado
            e estabelecido pela TREND por escrito. Nem a conduta entre as partes
            nem a prática comercial agirá para modificar qualquer provisão deste
            EULA. Você não poderá transferir este EULA nem nenhum de seus
            direitos nos termos deste EULA sem o prévio consentimento por
            escrito da TREND, que poderá ser concedido ou condicionado ao nosso
            exclusivo e absoluto critério, e qualquer tentativa de cessão sem
            consentimento será nula e inválida. Observada a restrição acima,
            este EULA será interpretado em benefício da TREND e de nossos
            respectivos sucessores e cessionários, será totalmente vinculativo
            para nós e será aplicável por nós. A TREND poderá transferir seus
            direitos e obrigações previstos nestes termos para outra
            organização.
          </li>
        </ol>
      </span>
    </React.Fragment>
  );
};

export default TermsAndCondition;



// WEBPACK FOOTER //
// ./src/components/signup/termsAndCondition/components/portugesse.js